import { render, staticRenderFns } from "./OutOfRegionSolutionModal.vue?vue&type=template&id=4b602438&scoped=true"
import script from "./OutOfRegionSolutionModal.vue?vue&type=script&lang=js"
export * from "./OutOfRegionSolutionModal.vue?vue&type=script&lang=js"
import style0 from "./OutOfRegionSolutionModal.vue?vue&type=style&index=0&id=4b602438&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b602438",
  null
  
)

export default component.exports